/* ============
 * ProductDeposit Transformer
 * ============
 *
 * todo: add documentation here!
 */

import Transformer from './transformer';

export default class ProductDepositTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      name: item.name,
      amount: item.amount,
      externalId: item.external_id,
    };
  }

  static send(item) {
    return {
      id: item.id,
      name: item.name,
      amount: item.amount,
      external_id: item.externalId,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productDeposit.js